export const commonTranslations = {
  vi: {
    nav: {
      home: "Trang chủ",
      ecosystem: "Hệ sinh thái",
      news: "Tin tức",
      careers: "Tuyển dụng",
      contact: "Liên hệ",
    },
    copied: "Đã sao chép liên kết!",
    categories: {
      "Hoạt động sinh nhật": "Hoạt động sinh nhật",
      "Văn hóa": "Văn hóa",
      "Tin tức": "Tin tức",
      "Sự kiện": "Sự kiện",
    },
    contact: {
      badge: "Kênh liên hệ bảo mật",
      title: "Sẵn Sàng",
      titleAccent: "Kết Nối?",
      subtitle: "Hãy để lại lời nhắn, đội ngũ chuyên gia của AHV sẽ phản hồi bạn trong 24h.",
      form: {
        name: "Họ và Tên",
        phone: "Số điện thoại",
        email: "Email liên hệ",
        company: "Công ty / Doanh nghiệp",
        message: "Lời nhắn của bạn",
        placeholder: {
          name: "Nguyễn Văn A",
          phone: "09xx xxx xxx",
          email: "contact@company.com",
          company: "Tên doanh nghiệp của bạn",
          message: "Bạn đang quan tâm đến giải pháp nào của AHV?"
        },
        submit: "Gửi yêu cầu ngay"
      },
      success: {
        title: "Gửi Thành Công!",
        subtitle: "Cảm ơn bạn đã quan tâm. Chúng tôi sẽ liên hệ sớm nhất."
      },
      footer: "AHV Holding • Bảo mật & Mã hóa"
    },
    footer: {
      links: "Liên kết nhanh",
      address: "Địa chỉ",
      phone: "Điện thoại",
      email: "Email",
      copyright: "© 2026 AHV Holding. Bảo lưu mọi quyền.",
      privacy: "Chính sách bảo mật",
      terms: "Điều khoản dịch vụ",
      cookies: "Chính sách cookies",
      offices: {
        tn: "Số Nhà 18, Tổ 1, P. Sông Công, Tỉnh Thái Nguyên",
        hn: "Tòa nhà TechCenter, Khu đô thị Cầu Giấy, Quận Cầu Giấy, TP. Hà Nội",
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      ecosystem: "Ecosystem",
      news: "News",
      careers: "Careers",
      contact: "Contact",
    },
    copied: "Link copied!",
    categories: {
      "Hoạt động sinh nhật": "Birthday Activities",
      "Văn hóa": "Culture",
      "Tin tức": "News",
      "Sự kiện": "Events",
    },
    contact: {
      badge: "Secure Communication",
      title: "Ready to",
      titleAccent: "Connect?",
      subtitle: "Leave a message, AHV's team of experts will respond within 24h.",
      form: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Contact Email",
        company: "Company / Business",
        message: "Your Message",
        placeholder: {
          name: "John Doe",
          phone: "09xx xxx xxx",
          email: "contact@company.com",
          company: "Your company name",
          message: "Which AHV solution are you interested in?"
        },
        submit: "Send Request Now"
      },
      success: {
        title: "Sent Successfully!",
        subtitle: "Thank you for your interest. We will contact you soon."
      },
      footer: "AHV Holding • Secure & Encrypted"
    },
    footer: {
      links: "Quick Links",
      address: "Address",
      phone: "Phone",
      email: "Email",
      copyright: "© 2026 AHV Holding. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      cookies: "Cookie Policy",
      offices: {
        tn: "No. 18, To 1, Song Cong Ward, Thai Nguyen Province",
        hn: "TechCenter Building, Cau Giay Urban Area, Cau Giay Dist., Hanoi",
      },
    },
  },
};

export const homeTranslations = {
  vi: {
    hero: {
      badge: "Kiến tạo Kỷ nguyên Số",
      title: "Hệ Sinh Thái Công Nghệ AHV",
      titlePart1: "Hệ sinh thái công nghệ",
      titlePart2: "bền vững",
      titlePart3: "cho tương lai",
      subtitle: "Giải pháp chuyển đổi số toàn diện cho doanh nghiệp hiện đại.",
      contactCTA: "Liên hệ tư vấn",
      cta: "Khám phá dịch vụ",
      getStarted: "Bắt đầu ngay",
      rocketSubtitle: "Bứt phá quy trình doanh nghiệp của bạn ngay hôm nay.",
      stats: {
        growth: "Tăng trưởng hiệu quả",
        projects: "Dự án tiêu biểu",
        market: "Hiệu suất thị trường",
      },
      statsLabel: "Tăng trưởng hiệu quả",
      ecosystemServices: "Dịch vụ hệ sinh thái",
      floatingCard: {
        marketTitle: "Hiệu suất thị trường",
        title: "Bắt đầu ngay",
        description: "Bứt phá quy trình doanh nghiệp của bạn ngay hôm nay.",
      },
    },
    about: {
      badge: "Về Chúng Tôi",
      title: "AHV",
      titleAccent: "Holding",
      description:
        "Công ty Cổ phần Đầu tư AHV Holding khởi đầu trong lĩnh vực cung cấp dịch vụ và giải pháp công nghệ thông tin cho tổ chức, doanh nghiệp và cá nhân trong và ngoài nước. Với định hướng nghiên cứu và phát triển các công nghệ mũi nhọn, AHV Holding không ngừng đổi mới và ứng dụng giải pháp tiên tiến, tạo nền tảng cho tăng trưởng bền vững và đáp ứng linh hoạt nhu cầu của thị trường trong kỷ nguyên số.",
      pillars: {
        bestSolution: "Giải Pháp Tốt Nhất",
        friendlyTeam: "Đội ngũ thân thiện và hỗ trợ",
        integrity: "Chính Trực",
        creativity: "Sáng Tạo",
        teamwork: "Đồng Đội",
        passion: "Đam Mê",
      },
      mission: {
        badge: "Sứ Mệnh",
        content:
          "AHV Holding cam kết mang đến cho cộng đồng Publisher, người dùng internet toàn cầu một hệ sinh thái chất lượng cao, an toàn bằng chính sự trân trọng và trách nhiệm cao của mình.",
      },
    },
    values: {
      badge: "DNA của AHV",
      title: "Giá Trị Cốt Lõi",
      description:
        "Nền tảng vững chắc định hình phong cách làm việc và sứ mệnh dẫn đầu của AHV Holding.",
      items: {
        "1": {
          title: "Tử tế",
          description:
            "Kinh doanh bằng sự chân thành, đối xử với khách hàng và đồng nghiệp bằng cái tâm.",
        },
        "2": {
          title: "Trung thực",
          description:
            "Minh bạch trong mọi quy trình, cam kết nói thật và làm thật trong mọi dự án.",
        },
        "3": {
          title: "Chia sẻ",
          description:
            "Cùng phát triển, sẵn lòng hỗ trợ cộng đồng và đối tác để kiến tạo giá trị chung.",
        },
        "4": {
          title: "Nhanh & Tốt",
          description:
            "Thích ứng linh hoạt, tối ưu quy trình để mang lại hiệu quả trong thời gian ngắn nhất.",
        },
      },
    },
    services: {
      badge: "Inside AHV",
      title: "Hệ Sinh Thái Dịch Vụ",
      description:
        "Giải pháp công nghệ đột phá, kiến tạo giá trị bền vững cho doanh nghiệp.",
      viewDetail: "Xem chi tiết",
      cta: "Xem tất cả dịch vụ",
            items: {
        "digital-infrastructure-and-cloud-transformation": {
          title: "Hạ tầng số",
          description: "Cung cấp giải pháp hạ tầng số toàn diện dựa trên nền tảng Điện toán đám mây (Cloud Computing) tiêu chuẩn quốc tế. Dịch vụ giúp doanh nghiệp tối ưu hóa chi phí vận hành, tăng cường khả năng mở rộng hệ thống linh hoạt và đảm bảo tính sẵn sàng cao (High Availability) cho các ứng dụng trọng yếu trong kỷ nguyên số."
        },
        "enterprise-cybersecurity-audit-and-protection": {
          title: "Khảo sát & Bảo vệ an ninh mạng",
          description: "Dịch vụ đánh giá an ninh mạng chuyên sâu giúp nhận diện và ngăn chặn các lỗ hổng bảo mật tiềm ẩn. Chúng tôi triển khai các hệ thống phòng thủ đa tầng, từ kiểm thử xâm nhập (Penetration Testing) đến giám sát an ninh 24/7, nhằm bảo vệ tài sản dữ liệu quý giá của doanh nghiệp trước các cuộc tấn công mạng ngày càng tinh vi."
        },
        "ai-powered-business-intelligence": {
          title: "Trí tuệ nhân tạo (AI) trong phân tích kinh doanh",
          description: "Khai phá sức mạnh từ dữ liệu thô thông qua các mô hình học máy (Machine Learning) và trí tuệ nhân tạo. Giải pháp của chúng tôi giúp doanh nghiệp xây dựng các bảng điều khiển (Dashboards) thời gian thực, dự báo xu hướng thị trường và hành vi khách hàng, từ đó đưa ra các quyết định chiến lược dựa trên dữ liệu chính xác."
        },
        "custom-erp-and-software-solutions": {
          title: "Giải pháp phần mềm & ERP",
          description: "Phát triển các hệ thống quản trị nguồn lực doanh nghiệp (ERP) và phần mềm theo yêu cầu, được may đo riêng cho từng quy trình nghiệp vụ đặc thù. Chúng tôi tập trung vào việc tối ưu hóa luồng công việc, tự động hóa các tác vụ lặp lại và đảm bảo khả năng tích hợp mượt mà với các hệ thống sẵn có của doanh nghiệp."
        },
        "digital-marketing-and-brand-positioning": {
          title: "Truyền thông số & Định vị thương hiệu",
          description: "Xây dựng chiến lược thương hiệu số đa kênh, kết hợp giữa tư duy sáng tạo và phân tích dữ liệu hiệu suất. Dịch vụ tập trung vào việc gia tăng điểm chạm với khách hàng mục tiêu, tối ưu hóa tỷ lệ chuyển đổi (CRO) và xây dựng lòng trung thành thương hiệu thông qua các nội dung mang tính dẫn dắt thị trường."
        },
        "real-estate-digital-management": {
          title: "Quản lý số Bất động sản",
          description: "Giải pháp quản lý dự án bất động sản thông minh, tích hợp công nghệ VR/AR và bản đồ số để minh bạch hóa thông tin dự án."
        },
        "strategic-corporate-consulting": {
          title: "Tư vấn Chiến lược Doanh nghiệp",
          description: "Tư vấn chiến lược tái cấu trúc doanh nghiệp và tối ưu hóa mô hình vận hành trong điều kiện thị trường biến động."
        },
        "e-learning-and-corporate-training-platforms": {
          title: "Nền tảng E-learning & Đào tạo",
          description: "Xây dựng hệ thống quản lý học tập (LMS) hiện đại giúp doanh nghiệp tự động hóa quy trình đào tạo nội bộ."
        },
        "supply-chain-data-integration": {
          title: "Tích hợp Dữ liệu Chuỗi cung ứng",
          description: "Tối ưu hóa chuỗi cung ứng bằng cách kết nối dữ liệu từ nhà cung cấp đến khách hàng cuối cùng."
        },
        "corporate-media-production": {
          title: "Sản xuất Truyền thông Doanh nghiệp",
          description: "Dịch vụ sản xuất nội dung số chuyên nghiệp, từ video giới thiệu doanh nghiệp đến các chiến dịch truyền thông cao cấp."
        }
      },
      },
      ecosystem: {
      badge: "Giải pháp toàn diện",
      title: "Hệ Sinh Thái Dịch Vụ",
      description:
        "Bộ giải pháp công nghệ tiên phong giúp doanh nghiệp bứt phá mọi giới hạn trong kỷ nguyên số.",
      items: {
        "kinh-nghiem": "Năm kinh nghiệm",
        "du-an": "Dự án hoàn tất",
        "chuyen-gia": "Chuyên gia IT",
        "doi-tac": "Đối tác toàn cầu",
      },
    },
    milestones: {
      title: "Cột Mốc Phát Triển",
      journeyTitle: "Hành trình vươn tầm",
      description:
        "Những bước ngoặt quan trọng đánh dấu sự trưởng thành và bứt phá của AHV Holding trên bản đồ công nghệ.",
      items: {
        "2022": {
          title: "TÁI CẤU TRÚC & CHUYỂN ĐỔI NỀN TẢNG",
          description:
            "Tập trung tối ưu hóa quy trình vận hành và xây dựng nền tảng công nghệ lõi mới.",
        },
        "2023": {
          title: "THÍCH ỨNG & CỦNG CỐ NỘI LỰC",
          description:
            "Vượt qua thử thách thị trường, khẳng định vị thế và mở rộng đội ngũ chuyên gia.",
        },
        "2024": {
          title: "KICK-OFF CHIẾN LƯỢC DÀI HẠN",
          description:
            "Khởi động các dự án trọng điểm hướng tới mục tiêu dẫn đầu hệ sinh thái số.",
        },
        "2025": {
          title: "TĂNG TỐC & MỞ RỘNG QUY MÔ",
          description:
            "Phát triển đột phá các giải pháp AI và Cloud, vươn tầm quy mô quốc tế.",
        },
      },
    },
    leadership: {
      badge: "Tầm nhìn chiến lược",
      title: "Đội Ngũ Lãnh Đạo",
      description:
        "Sự kết hợp giữa tư duy đổi mới và bề dày kinh nghiệm, đưa AHV vươn tầm quốc tế.",
      items: {
        "1": {
          name: "Ông Trần Đức Hiếu",
          title: "Giám Đốc Điều Hành (CEO)",
          description:
            "Chuyên gia chiến lược với hơn 15 năm kinh nghiệm dẫn dắt các tập đoàn công nghệ lớn.",
        },
        "2": {
          name: "Ông Đậu Nguyên Thế",
          title: "Giám Đốc Kinh Doanh",
          description:
            "Tiên phong trong việc ứng dụng AI và Blockchain vào các giải pháp doanh nghiệp thực tiễn.",
        },
        "3": {
          name: "Ông Chu Văn Tú",
          title: "Giám Đốc Công Nghệ (CTO)",
          description:
            "Tối ưu hóa quy trình vận hành Agile, đảm bảo hiệu suất tối đa cho toàn bộ hệ sinh thái.",
        },
        "4": {
          name: "Ông Lê Thanh Tùng",
          title: "Giám Đốc Kỹ Thuật",
          description:
            "Chuyên gia về kiến trúc hệ thống và chiến lược kỹ thuật cho các nền tảng số quy mô lớn.",
        },
        "6": {
          name: "Bà Trịnh Thị Lan Anh",
          title: "Giám đốc Tài Chính (CFO)",
          description:
            "Tối ưu hóa quy trình tài chính và đảm bảo sự phát triển bền vững cho tập đoàn.",
        },
      },
    },
    testimonials: {
      title: "Khách hàng nói gì về chúng tôi",
      badge: "Cảm nhận khách hàng",
      items: {
        "1": {
          content:
            "Hệ sinh thái của AHV thực sự thay đổi cách chúng tôi vận hành. Giải pháp Cloud và ERP may đo giúp tối ưu hóa 30% chi phí vận hành chỉ sau 6 tháng.",
          author: "Hoàng Nam",
          position: "CEO, TechCore Vietnam",
        },
        "2": {
          content:
            "Đội ngũ kỹ thuật của AHV rất chuyên nghiệp và nhanh nhẹn. Họ không chỉ bán sản phẩm mà còn đồng hành như một đối tác chiến lược thực thụ.",
          author: "Minh Anh",
          position: "CTO, EduSmart",
        },
        "3": {
          content:
            'Tôi đánh giá cao triết lý "Tử tế" của AHV. Sự minh bạch trong quy trình giúp chúng tôi hoàn toàn yên tâm khi triển khai các dự án quy mô lớn.',
          author: "Văn Đức",
          position: "Giám đốc, Global Logistics",
        },
        "4": {
          content:
            "Đội ngũ kỹ thuật của AHV rất chuyên nghiệp và nhanh nhẹn. Họ không chỉ bán sản phẩm mà còn đồng hành như một đối tác chiến lược thực thụ.",
          author: "Minh Anh",
          position: "CTO, EduSmart",
        },
        "5": {
          content:
            'Tôi đánh giá cao triết lý "Tử tế" của AHV. Sự minh bạch trong quy trình giúp chúng tôi hoàn toàn yên tâm khi triển khai các dự án quy mô lớn.',
          author: "Văn Đức",
          position: "Giám đốc, Global Logistics",
        },
      },
    },
    brands: {
      badge: "Hệ sinh thái AHV",
      title: "Thương Hiệu Thành Viên",
      description: "Những đơn vị nòng cốt kiến tạo giá trị đa dạng trong hệ sinh thái công nghệ của AHV Holding.",
      items: {
        "ahv-tech": {
          name: "AHV-TECH",
          description: "Đội ngũ trẻ, năng động, tập trung phát triển các dự án phần mềm. Team phối hợp chặt chẽ từ lập trình đến kiểm thử để đảm bảo chất lượng. Luôn hướng đến sự sáng tạo và cải tiến liên tục."
        },
        "ahv-modnix": {
          name: "AHV MODNIX",
          description: "Đầu tư và phát triển Mobile & AI Applications hướng đến thị trường toàn cầu, với hệ sinh thái sản phẩm đạt hơn 1 tỷ lượt tải."
        },
        "ahv-media": {
          name: "AHV MEDIA BRAND",
          description: "Sản xuất video hoạt hình giáo dục, giải trí lành mạnh cho trẻ em và gia đình, qua thương hiệu Buno – câu chuyện về cậu bé Trâu 10 tuổi."
        },
        "ahv-diy": {
          name: "AHV-DIY",
          description: "Kênh chia sẻ ý tưởng tái chế, mẹo vặt gia đình, phát minh thực tế và giải pháp nhà thông minh qua các video trực quan."
        },
        "ahv-cloud": {
          name: "AHV CLOUD",
          description: "Cung cấp dịch vụ máy chủ Infrastructure & Cloud linh hoạt, hiệu suất cao, đảm bảo an toàn dữ liệu và uptime ổn định."
        }
      }
    },
    news: {
      badge: "Tâm điểm công nghệ",
      title: "Tin Tức & Sự Kiện",
      description:
        "Cập nhật những chuyển động mới nhất từ AHV và xu hướng công nghệ toàn cầu.",
      viewAll: "Xem tất cả tin tức",
      readMore: "Đọc tiếp",
      viewDetails: "Xem chi tiết",

            items: {
        "tet-van-nien-cham-nhip-khoi-nguyen-bat-tan": {
          title: "TẾT VẠN NIÊN – CHẠM NHỊP KHỞI NGUYÊN BẤT TẬN",
          excerpt: "Tết không chỉ là khoảnh khắc đoàn viên, mà còn là thời điểm đại gia đình AHV cùng chạm chung một nhịp đập – nhịp đập của sáng tạo, của niềm tin và của những khởi đầu đầy năng lượng tích cực."
        },
        "83-ton-vinh-nhung-bong-hoa-cua-ahv": {
          title: "8/3 – TÔN VINH NHỮNG BÔNG HOA CỦA AHV",
          excerpt: "Hôm nay không chỉ là một ngày đặc biệt của một nửa thế giới, mà còn là dịp để AHV Holding dừng lại, nhìn lại và gửi lời cảm ơn chân thành nhất đến những bông hoa xinh đẹp và tài năng đang ngày ngày góp sức xây dựng đại gia đình AHV."
        },
        "happy-birthday-chuc-mung-sinh-nhat-nhan-su-thang-3": {
          title: "🎂 HAPPY BIRTHDAY – CHÚC MỪNG SINH NHẬT NHÂN SỰ THÁNG 3",
          excerpt: "Tháng 3 không chỉ là tháng của những bông hoa khoe sắc và tiết trời dịu mát, mà còn là tháng đặc biệt đánh dấu ngày chào đời của những thành viên đáng quý trong đại gia đình AHV Holding."
        },
        "tinh-than-the-thao-nang-luong-ket-noi-tai-ahv-holding": {
          title: "TINH THẦN THỂ THAO – NĂNG LƯỢNG KẾT NỐI TẠI AHV HOLDING",
          excerpt: "Trong nhịp sống hiện đại với guồng công việc không ngừng nghỉ, AHV Holding luôn xác định rằng chăm sóc sức khỏe thể chất và tinh thần cho đội ngũ là một trong những ưu tiên hàng đầu."
        }
      },
    },
    careers: {
      badge: "Gia nhập AHV",
      title: "Cơ Hội Nghề Nghiệp",
      description:
        "Chúng tôi luôn tìm kiếm những cộng sự tài năng để cùng xây dựng tương lai số.",
      viewAll: "Xem tất cả vị trí",
      jobInfo: {
        "Toàn thời gian": "Toàn thời gian",
        "Full-time": "Toàn thời gian",
        "Bán thời gian": "Bán thời gian",
        "Part-time": "Bán thời gian",
        "Từ xa": "Từ xa",
        "Remote": "Từ xa",
        "Hybrid": "Kết hợp",
        "Hà Nội": "Hà Nội",
        "Hanoi": "Hà Nội",
        "Thái Nguyên": "Thái Nguyên",
        "Thai Nguyen": "Thái Nguyên",
        "TPHCM": "TP. Hồ Chí Minh",
        "TP Hồ Chí Minh": "TP. Hồ Chí Minh",
      },
      values: {
        "1": {
          title: "Môi trường Agile",
          description: "Quy trình hiện đại, linh hoạt và không ngừng sáng tạo.",
        },
        "2": {
          title: "Lộ trình rõ ràng",
          description:
            "Chính sách đào tạo và phát triển năng lực được ưu tiên hàng đầu.",
        },
        "3": {
          title: "Công nghệ tiên phong",
          description:
            "Luôn tiếp cận và ứng dụng các công nghệ mới nhất trên thế giới.",
        },
        "4": {
          title: "Văn hóa mở",
          description:
            "Khuyến khích chia sẻ ý tưởng và trao quyền quyết định cho mỗi cá nhân.",
        },
        "5": {
          title: "Chăm sóc toàn diện",
          description:
            "Đãi ngộ hấp dẫn, bảo hiểm sức khỏe cao cấp cho nhân viên và gia đình.",
        },
        "6": {
          title: "Cân bằng cuộc sống",
          description:
            "Thời gian làm việc linh hoạt, chú trọng sự gắn kết qua các hoạt động teambuilding.",
        },
      },
    },
    map: {
      title: "Văn phòng AHV",
      offices: {
        tn: {
          name: "Trụ sở Thái Nguyên",
          address: "Số Nhà 18, Tổ 1, P. Sông Công, Tỉnh Thái Nguyên",
        },
        hn: {
          name: "Văn phòng Hà Nội",
          address: "Số 8/116 Nhân Hòa, Thanh Xuân, Hà Nội",
        },
      },
    },
  },
  en: {
    hero: {
      badge: "Architecting the Digital Era",
      title: "AHV Technology Ecosystem",
      titlePart1: "Technology ecosystem",
      titlePart2: "sustainable",
      titlePart3: "for the future",
      subtitle:
        "Comprehensive digital transformation solutions for modern enterprises.",
      contactCTA: "Contact for Advice",
      cta: "Explore Services",
      getStarted: "Get Started Now",
      rocketSubtitle: "Breakthrough your business processes today.",
      stats: {
        growth: "Effective Growth",
        projects: "Key Projects",
        market: "Market Performance",
      },
      statsLabel: "Efficient Growth",
      ecosystemServices: "Ecosystem Services",
      floatingCard: {
        marketTitle: "Market Performance",
        title: "Get Started",
        description: "Breakthrough your business processes today.",
      },
    },
    about: {
      badge: "About Us",
      title: "AHV",
      titleAccent: "Holding",
      description:
        "AHV Holding Joint Stock Company started in the field of providing IT services and solutions for organizations, businesses and individuals domestically and internationally. With a focus on researching and developing cutting-edge technologies, AHV Holding continuously innovates and applies advanced solutions, creating a foundation for sustainable growth and flexibly meeting market demands in the digital era.",
      pillars: {
        bestSolution: "Best Solutions",
        friendlyTeam: "Friendly & Supportive Team",
        integrity: "Integrity",
        creativity: "Creativity",
        teamwork: "Teamwork",
        passion: "Passion",
      },
      mission: {
        badge: "Mission",
        content:
          "AHV Holding is committed to bringing the global Publisher community and internet users a high-quality, safe ecosystem with our utmost respect and responsibility.",
      },
    },
    values: {
      badge: "DNA of AHV",
      title: "Core Values",
      description:
        "A solid foundation shaping the working style and leading mission of AHV Holding.",
      items: {
        "1": {
          title: "Integrity",
          description:
            "Doing business with sincerity, treating customers and colleagues with heart.",
        },
        "2": {
          title: "Honesty",
          description:
            "Transparency in every process, committing to speaking the truth and doing real work in every project.",
        },
        "3": {
          title: "Sharing",
          description:
            "Growing together, willing to support the community and partners to create shared value.",
        },
        "4": {
          title: "Fast & Quality",
          description:
            "Adapting flexibly, optimizing processes to bring efficiency in the shortest time.",
        },
      },
    },
    services: {
      badge: "Inside AHV",
      title: "Service Ecosystem",
      description:
        "Breakthrough technology solutions, creating sustainable value for businesses.",
      viewDetail: "View Details",
      cta: "View all services",
            items: {
        "digital-infrastructure-and-cloud-transformation": {
          title: "Digital Infrastructure & Cloud Transformation",
          description: "Providing comprehensive digital infrastructure solutions based on international-standard Cloud Computing platforms. Services help businesses optimize operational costs, enhance system scalability, and ensure High Availability for mission-critical applications."
        },
        "enterprise-cybersecurity-audit-and-protection": {
          title: "Enterprise Cybersecurity Audit & Protection",
          description: "In-depth cybersecurity assessment services to identify and prevent potential security vulnerabilities. We deploy multi-layered defense systems, from Penetration Testing to 24/7 security monitoring, to protect your business's valuable data assets."
        },
        "ai-powered-business-intelligence": {
          title: "AI-Powered Business Intelligence",
          description: "Unlocking the power of raw data through Machine Learning and Artificial Intelligence models. Our solutions help businesses build real-time Dashboards, forecast market trends, and make data-driven strategic decisions."
        },
        "custom-erp-and-software-solutions": {
          title: "Custom ERP & Software Solutions",
          description: "Developing tailor-made Enterprise Resource Planning (ERP) systems and custom software to optimize business workflows, automate repetitive tasks, and ensure seamless integration with existing systems."
        },
        "digital-marketing-and-brand-positioning": {
          title: "Digital Marketing & Brand Positioning",
          description: "Building multi-channel digital brand strategies combining creative thinking and performance data analysis. Focused on increasing customer touchpoints, Conversion Rate Optimization (CRO), and building brand loyalty."
        },
        "real-estate-digital-management": {
          title: "Real Estate Digital Management",
          description: "Smart real estate management solutions, integrating VR/AR and digital maps for transparency in project information."
        },
        "strategic-corporate-consulting": {
          title: "Strategic Corporate Consulting",
          description: "Corporate restructuring and operational model optimization consulting for fluctuating market conditions."
        },
        "e-learning-and-corporate-training-platforms": {
          title: "E-learning & Corporate Training Platforms",
          description: "Modern LMS helping businesses automate internal training processes and personalize learning paths."
        },
        "supply-chain-data-integration": {
          title: "Supply Chain Data Integration",
          description: "Optimizing supply chain by connecting data from suppliers to end customers for global logistics efficiency."
        },
        "corporate-media-production": {
          title: "Corporate Media Production",
          description: "Professional digital content production, from corporate videos to premium visual communication campaigns."
        }
      },
      },
      ecosystem: {
      badge: "Comprehensive Solution",
      title: "Service Ecosystem",
      description:
        "Pioneering technology solutions helping businesses break all limits in the digital era.",
      items: {
        "kinh-nghiem": "Years of Experience",
        "du-an": "Completed Projects",
        "chuyen-gia": "IT Experts",
        "doi-tac": "Global Partners",
        "ha-tang-so": "Digital Infrastructure",
        "giai-phap-phan-mem": "Software Solutions",
        "edtech": "EdTech",
        "media-studio": "Media & DIY",
      },
    },
    milestones: {
      title: "Company Milestones",
      journeyTitle: "Our Journey",
      description:
        "Key turning points marking the growth and breakthrough of AHV Holding in the technology map.",
      items: {
        "2022": {
          title: "RESTRUCTURING & PLATFORM TRANSFORMATION",
          description:
            "Focusing on optimizing operational processes and building new core technology platforms.",
        },
        "2023": {
          title: "ADAPTATION & STRENGTHENING INNER FORCE",
          description:
            "Overcoming market challenges, affirming position, and expanding the expert team.",
        },
        "2024": {
          title: "KICK-OFF LONG-TERM STRATEGY",
          description:
            "Launching key projects aiming for leadership in the digital ecosystem.",
        },
        "2025": {
          title: "ACCELERATION & SCALE EXPANSION",
          description:
            "Breakthrough development of AI and Cloud solutions, reaching international scale.",
        },
        "2025 - Nay": {
          title: "ACCELERATION & SCALE EXPANSION",
          description:
            "Breakthrough development of AI and Cloud solutions, reaching international scale.",
        },
      },
    },
    leadership: {
      badge: "Strategic Vision",
      title: "Leadership Team",
      description:
        "A combination of innovative thinking and extensive experience, taking AHV to the international level.",
      items: {
        "1": {
          name: "Mr. Tran Duc Hieu",
          title: "CEO",
          description:
            "Strategic expert with over 15 years of experience leading major technology corporations.",
        },
        "2": {
          name: "Mr. Dau Nguyen The",
          title: "Sales Director",
          description:
            "Pioneer in applying AI and Blockchain to practical business solutions.",
        },
        "3": {
          name: "Mr. Chu Van Tu",
          title: "CTO",
          description:
            "Optimizing Agile operations and ensuring peak performance across the entire ecosystem.",
        },
        "4": {
          name: "Mr. Le Thanh Tung",
          title: "Technical Director",
          description:
            "Expert in system architecture and technical strategy for large-scale digital platforms.",
        },
        "6": {
          name: "Ms. Trinh Thi Lan Anh",
          title: "CFO",
          description:
            "Optimizing financial operations and driving sustainable growth for the group.",
        },
      },
    },
    testimonials: {
      title: "What clients say about us",
      badge: "Client Testimonials",
      items: {
        "1": {
          content:
            "AHV's ecosystem has truly changed the way we operate. Custom Cloud and ERP solutions helped optimize 30% of operating costs after just 6 months.",
          author: "Hoang Nam",
          position: "CEO, TechCore Vietnam",
        },
        "2": {
          content:
            "AHV's technical team is very professional and agile. They don't just sell products but accompany us as a true strategic partner.",
          author: "Minh Anh",
          position: "CTO, EduSmart",
        },
        "3": {
          content:
            'I highly appreciate AHV\'s "Kindness" philosophy. Transparency in the process helps us feel completely assured when implementing large-scale projects.',
          author: "Van Duc",
          position: "Director, Global Logistics",
        },
        "4": {
          content:
            "AHV's technical team is very professional and agile. They don't just sell products but accompany us as a true strategic partner.",
          author: "Minh Anh",
          position: "CTO, EduSmart",
        },
        "5": {
          content:
            'I highly appreciate AHV\'s "Kindness" philosophy. Transparency in the process helps us feel completely assured when implementing large-scale projects.',
          author: "Van Duc",
          position: "Director, Global Logistics",
        },
      },
    },
    brands: {
      badge: "AHV Ecosystem",
      title: "Subsidiary Brands",
      description: "The core units creating diverse value within AHV Holding's technology ecosystem.",
      items: {
        "ahv-tech": {
          name: "AHV-TECH",
          description: "Young, dynamic team focused on software development. Seamless collaboration from coding to testing. Always striving for creativity and continuous improvement."
        },
        "ahv-modnix": {
          name: "AHV MODNIX",
          description: "Investing in and developing Mobile & AI Applications for the global market, with an ecosystem reaching over 1 billion downloads."
        },
        "ahv-media": {
          name: "AHV MEDIA BRAND",
          description: "Producing educational and healthy entertainment animated videos for children and families via the Buno brand."
        },
        "ahv-diy": {
          name: "AHV-DIY",
          description: "Channel for recycling ideas, home hacks, practical inventions, and smart home solutions through visual, easy-to-follow videos."
        },
        "ahv-cloud": {
          name: "AHV CLOUD",
          description: "Providing flexible, high-performance Infrastructure & Cloud server services, ensuring data security and stable uptime."
        }
      }
    },
    news: {
      badge: "Tech Spotlight",
      title: "News & Events",
      description:
        "Updating the latest movements from AHV and global technology trends.",
      viewAll: "View all news",
      readMore: "Read more",
      viewDetails: "View details",

            items: {
        "tet-van-nien-cham-nhip-khoi-nguyen-bat-tan": {
          title: "ETERNAL TET – TOUCH THE RHYTHM OF ENDLESS ORIGINS",
          excerpt: "Tet is not only a reunion moment but also a time for the AHV family to share a heartbeat of creativity, trust, and fresh starts filled with positive energy."
        },
        "83-ton-vinh-nhung-bong-hoa-cua-ahv": {
          title: "MARCH 8 – HONORING THE WOMEN OF AHV",
          excerpt: "Today is a special chance for AHV Holding to pause and send our deepest gratitude to the beautiful and talented \"flowers\" who contribute daily to building the AHV family."
        },
        "happy-birthday-chuc-mung-sinh-nhat-nhan-su-thang-3": {
          title: "🎂 HAPPY BIRTHDAY – CELEBRATING MARCH BABIES",
          excerpt: "March is not only the month of blooming flowers and cool weather, but also a special month marking the birth of cherished members in the AHV Holding family."
        },
        "tinh-than-the-thao-nang-luong-ket-noi-tai-ahv-holding": {
          title: "SPORTSMANSHIP – CONNECTING ENERGY AT AHV",
          excerpt: "In modern life with constant workflows, AHV Holding prioritizes physical and mental well-being for the team, as a healthy team is the foundation for success."
        }
      },
    },
    careers: {
      badge: "Join AHV",
      title: "Career Opportunities",
      description:
        "We are always looking for talented associates to build the digital future together.",
      viewAll: "View all positions",
      jobInfo: {
        "Toàn thời gian": "Full-time",
        "Full-time": "Full-time",
        "Bán thời gian": "Part-time",
        "Part-time": "Part-time",
        "Từ xa": "Remote",
        "Remote": "Remote",
        "Hybrid": "Hybrid",
        "Hà Nội": "Hanoi",
        "Hanoi": "Hanoi",
        "Thái Nguyên": "Thai Nguyen",
        "Thai Nguyen": "Thai Nguyen",
        "TPHCM": "Ho Chi Minh City",
        "TP Hồ Chí Minh": "Ho Chi Minh City",
      },
      values: {
        "1": {
          title: "Agile Environment",
          description: "Modern, flexible and constantly creative processes.",
        },
        "2": {
          title: "Clear Roadmap",
          description:
            "Training and performance development policies are a top priority.",
        },
        "3": {
          title: "Pioneer Technology",
          description:
            "Always accessing and applying the latest technologies in the world.",
        },
        "4": {
          title: "Open Culture",
          description:
            "Encouraging idea sharing and empowering individual decision-making.",
        },
        "5": {
          title: "Comprehensive Care",
          description:
            "Attractive benefits, high-end health insurance for employees and families.",
        },
        "6": {
          title: "Work-Life Balance",
          description:
            "Flexible working hours, focusing on engagement through teambuilding activities.",
        },
      },
    },
    map: {
      title: "AHV Offices",
      offices: {
        tn: {
          name: "Thai Nguyen Headquarter",
          address: "No. 123, Cach Mang Thang Tam St., Thai Nguyen City",
        },
        hn: {
          name: "Hanoi Office",
          address: "TechCenter Building, Cau Giay District, Hanoi",
        },
      },
    },
  },
};

export const ecosystemPageTranslations = {
  vi: {
    hero: {
      badge: "Hệ sinh thái công nghệ",
      title: "Kiến tạo tương lai",
      titleAccent: "bền vững",
      subtitle:
        "Hệ sinh thái đa ngành tích hợp các giải pháp số tiên phong, thúc đẩy sự thịnh vượng thông qua công nghệ và đổi mới sáng tạo.",
      cta: "Khám phá ngay",
      viewProjects: "Xem dự án",
    },
    services: {
      title: "Dịch Vụ Chiến Lược",
      subtitle:
        "Chúng tôi cung cấp các giải pháp toàn diện từ hạ tầng đến ứng dụng người dùng cuối.",
      description:
        "Tối ưu hóa vận hành và mở rộng khả năng tiếp cận thị trường với bộ giải pháp toàn diện.",
      viewMore: "Xem thêm",
      items: {
        "digital-infrastructure-and-cloud-transformation": {
          title: "Hạ tầng số",
          description: "Cung cấp giải pháp hạ tầng số toàn diện dựa trên nền tảng Điện toán đám mây (Cloud Computing) tiêu chuẩn quốc tế. Dịch vụ giúp doanh nghiệp tối ưu hóa chi phí vận hành, tăng cường khả năng mở rộng hệ thống linh hoạt và đảm bảo tính sẵn sàng cao (High Availability) cho các ứng dụng trọng yếu trong kỷ nguyên số."
        },
        "enterprise-cybersecurity-audit-and-protection": {
          title: "Khảo sát & Bảo vệ an ninh mạng",
          description: "Dịch vụ đánh giá an ninh mạng chuyên sâu giúp nhận diện và ngăn chặn các lỗ hổng bảo mật tiềm ẩn. Chúng tôi triển khai các hệ thống phòng thủ đa tầng, từ kiểm thử xâm nhập (Penetration Testing) đến giám sát an ninh 24/7, nhằm bảo vệ tài sản dữ liệu quý giá của doanh nghiệp trước các cuộc tấn công mạng ngày càng tinh vi."
        },
        "ai-powered-business-intelligence": {
          title: "Trí tuệ nhân tạo (AI) trong phân tích kinh doanh",
          description: "Khai phá sức mạnh từ dữ liệu thô thông qua các mô hình học máy (Machine Learning) và trí tuệ nhân tạo. Giải pháp của chúng tôi giúp doanh nghiệp xây dựng các bảng điều khiển (Dashboards) thời gian thực, dự báo xu hướng thị trường và hành vi khách hàng, từ đó đưa ra các quyết định chiến lược dựa trên dữ liệu chính xác."
        },
        "custom-erp-and-software-solutions": {
          title: "Giải pháp phần mềm & ERP",
          description: "Phát triển các hệ thống quản trị nguồn lực doanh nghiệp (ERP) và phần mềm theo yêu cầu, được may đo riêng cho từng quy trình nghiệp vụ đặc thù. Chúng tôi tập trung vào việc tối ưu hóa luồng công việc, tự động hóa các tác vụ lặp lại và đảm bảo khả năng tích hợp mượt mà với các hệ thống sẵn có của doanh nghiệp."
        },
        "digital-marketing-and-brand-positioning": {
          title: "Truyền thông số & Định vị thương hiệu",
          description: "Xây dựng chiến lược thương hiệu số đa kênh, kết hợp giữa tư duy sáng tạo và phân tích dữ liệu hiệu suất. Dịch vụ tập trung vào việc gia tăng điểm chạm với khách hàng mục tiêu, tối ưu hóa tỷ lệ chuyển đổi (CRO) và xây dựng lòng trung thành thương hiệu thông qua các nội dung mang tính dẫn dắt thị trường."
        },
        "real-estate-digital-management": {
          title: "Quản lý số Bất động sản",
          description: "Giải pháp quản lý dự án bất động sản thông minh, tích hợp công nghệ VR/AR và bản đồ số để minh bạch hóa thông tin dự án."
        },
        "strategic-corporate-consulting": {
          title: "Tư vấn Chiến lược Doanh nghiệp",
          description: "Tư vấn chiến lược tái cấu trúc doanh nghiệp và tối ưu hóa mô hình vận hành trong điều kiện thị trường biến động."
        },
        "e-learning-and-corporate-training-platforms": {
          title: "Nền tảng E-learning & Đào tạo",
          description: "Xây dựng hệ thống quản lý học tập (LMS) hiện đại giúp doanh nghiệp tự động hóa quy trình đào tạo nội bộ."
        },
        "supply-chain-data-integration": {
          title: "Tích hợp Dữ liệu Chuỗi cung ứng",
          description: "Tối ưu hóa chuỗi cung ứng bằng cách kết nối dữ liệu từ nhà cung cấp đến khách hàng cuối cùng."
        },
        "corporate-media-production": {
          title: "Sản xuất Truyền thông Doanh nghiệp",
          description: "Dịch vụ sản xuất nội dung số chuyên nghiệp, từ video giới thiệu doanh nghiệp đến các chiến dịch truyền thông cao cấp."
        }
      },
    },
    detail: {
      backToEcosystem: "Quay lại Hệ sinh thái",
      serviceOverview: "Tổng quan dịch vụ",
      keyFeatures: "Tính năng nổi bật",
      contactConsultant: "Liên hệ tư vấn",
      serviceNotFound: "Không tìm thấy dịch vụ",
      tryAgain: "Thử lại",
      efficiencyTitle: "Tối ưu hiệu quả",
      efficiencySubtitle: "Giảm thiểu 30% chi phí vận hành và tăng năng suất lên đến 50% cho doanh nghiệp.",
      advantages: {
        title: "Lợi thế",
        titleAccent: "Cạnh tranh",
        description: "Chúng tôi mang đến những giá trị vượt trội giúp doanh nghiệp tối ưu hoá mọi quy trình vận hành.",
        items: {
          0: {
            title: "Bảo mật tuyệt đối",
            desc: "Áp dụng tiêu chuẩn an toàn thông tin khắt khe nhất, bảo vệ dữ liệu doanh nghiệp an toàn 24/7."
          },
          1: {
            title: "Tối ưu hóa chi phí",
            desc: "Mô hình pay-as-you-go linh hoạt giúp tiết kiệm đến 40% chi phí vận hành hệ thống IT."
          },
          2: {
            title: "Khả năng mở rộng",
            desc: "Kiến trúc độc lập và linh hoạt, dễ dàng mở rộng quy mô kinh doanh không giới hạn."
          }
        }
      },
      items: {
        "digital-infrastructure-and-cloud-transformation": {
          overview: "Cung cấp hạ tầng Cloud & Server mạnh mẽ, bảo mật và linh hoạt, giúp doanh nghiệp vận hành ổn định trên nền tảng số.",
          features: [
            "Hệ thống Cloud Server hiệu năng cao",
            "Bảo mật đa lớp tiêu chuẩn quốc tế",
            "Khả năng mở rộng linh hoạt",
            "Hỗ trợ kỹ thuật 24/7 chuyên nghiệp"
          ]
        },
        "enterprise-cybersecurity-audit-and-protection": {
          overview: "Khảo sát và triển khai các hệ thống an ninh mạng chuyên sâu, bảo vệ dữ liệu và hạ tầng của doanh nghiệp.",
          features: [
            "Đánh giá lỗ hổng bảo mật",
            "Phòng chống tấn công mạng 24/7",
            "Tuân thủ tiêu chuẩn an toàn thông tin",
            "Phục hồi sau sự cố"
          ]
        },
        "ai-powered-business-intelligence": {
          overview: "Ứng dụng các mô học máy và trí tuệ nhân tạo để khai triển giá trị từ dữ liệu kinh doanh.",
          features: [
            "Phân tích dữ liệu dự báo",
            "Tự động hóa bằng AI",
            "Xây dựng Dashboard thông minh",
            "Xử lý ngôn ngữ tự nhiên"
          ]
        },
        "custom-erp-and-software-solutions": {
          overview: "Thiết kế và phát triển các hệ thống ERP và phần mềm may đo, tối ưu hóa quy trình quản trị nội bộ.",
          features: [
            "Tự động hóa quy trình nghiệp vụ",
            "Tích hợp hệ thống liền mạch",
            "Nâng cấp hạ tầng phần mềm cũ",
            "Hệ thống báo cáo quản trị tập trung"
          ]
        },
        "digital-marketing-and-brand-positioning": {
          overview: "Định vị thương hiệu và thực thi các chiến dịch marketing số đa kênh dựa trên dữ liệu hiệu suất.",
          features: [
            "Chiến lược Marketing đa kênh",
            "Tối ưu hóa tỷ lệ chuyển đổi",
            "Phát triển nội dung sáng tạo",
            "Quản trị danh tiếng trực tuyến"
          ]
        },
        "real-estate-digital-management": {
          overview: "Giải pháp quản lý bất động sản toàn diện, tối ưu hóa quy trình từ bán hàng đến vận hành.",
          features: [
            "Quản lý giỏ hàng trực tuyến",
            "Tích hợp VR/AR xem dự án",
            "Quản trị hợp đồng điện tử",
            "Báo cáo thị trường thời gian thực"
          ]
        },
        "strategic-corporate-consulting": {
          overview: "Tư vấn chuyên sâu giúp doanh nghiệp tái cấu trúc và thích ứng với kỷ nguyên số.",
          features: [
            "Hoạch định chiến lược kinh doanh",
            "Tối ưu hóa bộ máy vận hành",
            "Tư vấn chuyển đổi số doanh nghiệp",
            "Đào tạo đội ngũ lãnh đạo"
          ]
        },
        "e-learning-and-corporate-training-platforms": {
          overview: "Nền tảng đào tạo trực tuyến hiện đại, giúp số hóa tri thức doanh nghiệp.",
          features: [
            "Hệ thống quản lý học tập LMS",
            "Kho nội dung số tương tác",
            "Cá nhân hóa lộ trình học tập",
            "Hệ thống chứng chỉ tự động"
          ]
        },
        "supply-chain-data-integration": {
          overview: "Kết nối và tối ưu hóa dòng chảy thông tin trong chuỗi cung ứng toàn cầu.",
          features: [
            "Tự động hóa luồng dữ liệu SC",
            "Dự báo nhu cầu bằng AI",
            "Quản trị rủi ro chuỗi cung ứng",
            "Tích hợp logistics đa kênh"
          ]
        },
        "corporate-media-production": {
          overview: "Sáng tạo nội dung truyền thông đỉnh cao, nâng tầm giá trị thương hiệu.",
          features: [
            "Sản xuất Video Viral/TVC",
            "Chụp ảnh thương hiệu chuyên nghiệp",
            "Thiết kế bộ nhận diện thương hiệu",
            "Xây dựng câu chuyện thương hiệu"
          ]
        }
      }
    },
    advantages: {
      title: "Lợi thế",
      titleAccent: "vượt trội",
      description:
        "Hệ sinh thái AHV tự hào mang lại những giá trị thiết thực và sự an tâm tuyệt đối cho khách hàng và đối tác.",
      items: [
        {
          title: "Bảo mật tuyệt đối",
          desc: "Áp dụng tiêu chuẩn an toàn thông tin khắt khe nhất, bảo vệ dữ liệu doanh nghiệp an toàn 24/7.",
        },
        {
          title: "Tối ưu hóa chi phí",
          desc: "Mô hình pay-as-you-go linh hoạt giúp tiết kiệm đến 40% chi phí vận hành hệ thống IT.",
        },
        {
          title: "Khả năng mở rộng",
          desc: "Kiến trúc độc lập và linh hoạt, dễ dàng mở rộng quy mô kinh doanh không giới hạn.",
        },
      ],
    },
    stats: {
      items: {
        "kinh-nghiem": "Năm kinh nghiệm",
        "du-an": "Dự án hoàn thành",
        "doi-tac": "Đối tác toàn cầu",
        "chuyen-gia": "Chuyên gia cốt cán",
      },
    },
    cta: {
      title: "Gia nhập hệ sinh thái",
      titleAccent: "công nghệ hàng đầu",
      subtitle:
        "Cùng AHV Holding xây dựng những giá trị mới bền vững và thịnh vượng thông qua sức mạnh của công nghệ.",
      primary: "Hợp tác ngay",
      secondary: "Tìm hiểu thêm",
      joinNow: "Hợp tác ngay",
      learnMore: "Tìm hiểu thêm",
    },
  },
  en: {
    hero: {
      badge: "Technology Ecosystem",
      title: "Architecting a",
      titleAccent: "Sustainable Future",
      subtitle:
        "A multi-sectoral ecosystem integrating pioneering digital solutions, driving prosperity through technology and innovation.",
      cta: "Explore Now",
      viewProjects: "View Projects",
    },
    services: {
      title: "Strategic Services",
      subtitle:
        "We provide comprehensive solutions from infrastructure to end-user applications.",
      description:
        "Optimize operations and expand market reach with a comprehensive solution suite.",
      viewMore: "Learn more",
      items: {
        "digital-infrastructure-and-cloud-transformation": {
          title: "Digital Infrastructure & Cloud Transformation",
          description: "Providing comprehensive digital infrastructure solutions based on international-standard Cloud Computing platforms. Services help businesses optimize operational costs, enhance system scalability, and ensure High Availability for mission-critical applications."
        },
        "enterprise-cybersecurity-audit-and-protection": {
          title: "Enterprise Cybersecurity Audit & Protection",
          description: "In-depth cybersecurity assessment services to identify and prevent potential security vulnerabilities. We deploy multi-layered defense systems, from Penetration Testing to 24/7 security monitoring, to protect your business's valuable data assets."
        },
        "ai-powered-business-intelligence": {
          title: "AI-Powered Business Intelligence",
          description: "Unlocking the power of raw data through Machine Learning and Artificial Intelligence models. Our solutions help businesses build real-time Dashboards, forecast market trends, and make data-driven strategic decisions."
        },
        "custom-erp-and-software-solutions": {
          title: "Custom ERP & Software Solutions",
          description: "Developing tailor-made Enterprise Resource Planning (ERP) systems and custom software to optimize business workflows, automate repetitive tasks, and ensure seamless integration with existing systems."
        },
        "digital-marketing-and-brand-positioning": {
          title: "Digital Marketing & Brand Positioning",
          description: "Building multi-channel digital brand strategies combining creative thinking and performance data analysis. Focused on increasing customer touchpoints, Conversion Rate Optimization (CRO), and building brand loyalty."
        },
        "real-estate-digital-management": {
          title: "Real Estate Digital Management",
          description: "Smart real estate management solutions, integrating VR/AR and digital maps for transparency in project information."
        },
        "strategic-corporate-consulting": {
          title: "Strategic Corporate Consulting",
          description: "Corporate restructuring and operational model optimization consulting for fluctuating market conditions."
        },
        "e-learning-and-corporate-training-platforms": {
          title: "E-learning & Corporate Training Platforms",
          description: "Modern LMS helping businesses automate internal training processes and personalize learning paths."
        },
        "supply-chain-data-integration": {
          title: "Supply Chain Data Integration",
          description: "Optimizing supply chain by connecting data from suppliers to end customers for global logistics efficiency."
        },
        "corporate-media-production": {
          title: "Corporate Media Production",
          description: "Professional digital content production, from corporate videos to premium visual communication campaigns."
        }
      },
    },
    detail: {
      backToEcosystem: "Back to Ecosystem",
      serviceOverview: "Service Overview",
      keyFeatures: "Key Features",
      contactConsultant: "Contact Consultant",
      serviceNotFound: "Service not found",
      tryAgain: "Try again",
      efficiencyTitle: "Efficiency Optimization",
      efficiencySubtitle: "Reduce operating costs by 30% and increase productivity by up to 50% for businesses.",
      advantages: {
        title: "Competitive",
        titleAccent: "Advantages",
        description: "We bring superior values that help businesses optimize all operational processes.",
        items: {
          0: {
            title: "Absolute Security",
            desc: "Applying the strictest information security standards, protecting business data safely 24/7."
          },
          1: {
            title: "Cost Optimization",
            desc: "Flexible pay-as-you-go model helps save up to 40% in IT system operation costs."
          },
          2: {
            title: "Scalability",
            desc: "Independent and flexible architecture, easily expanding business scale without limits."
          }
        }
      },
      items: {
        "digital-infrastructure-and-cloud-transformation": {
          overview: "Providing powerful, secure, and flexible Cloud & Server infrastructure, helping businesses operate stably on digital platforms.",
          features: [
            "High-performance Cloud Server system",
            "International standard multi-layer security",
            "Flexible Scalability",
            "Professional 24/7 technical support"
          ]
        },
        "enterprise-cybersecurity-audit-and-protection": {
          overview: "In-depth cybersecurity assessment and multi-layered defense system deployment to protect your digital assets.",
          features: [
            "Vulnerability Assessment",
            "24/7 Threat Protection",
            "Security Standard Compliance",
            "Disaster Recovery"
          ]
        },
        "ai-powered-business-intelligence": {
          overview: "Leveraging machine learning and artificial intelligence models to unlock true value from business data.",
          features: [
            "Predictive Data Analytics",
            "AI Workflow Automation",
            "Smart Dashboard Building",
            "Natural Language Processing"
          ]
        },
        "custom-erp-and-software-solutions": {
          overview: "Designing and developing tailor-made ERP systems and custom software to optimize internal governance.",
          features: [
            "Business Process Automation",
            "Seamless System Integration",
            "Legacy Infrastructure Modernization",
            "Centralized Management Reporting"
          ]
        },
        "digital-marketing-and-brand-positioning": {
          overview: "Brand positioning and executing multi-channel digital marketing campaigns based on performance data.",
          features: [
            "Omnichannel Marketing Strategy",
            "Conversion Rate Optimization",
            "Creative Content Development",
            "Online Reputation Management"
          ]
        },
        "real-estate-digital-management": {
          overview: "Comprehensive real estate management solutions, optimizing processes from sales to operations.",
          features: [
            "Online inventory management",
            "VR/AR project visualization",
            "E-contract administration",
            "Real-time market reporting"
          ]
        },
        "strategic-corporate-consulting": {
          overview: "In-depth consulting helping businesses restructure and adapt to the digital age.",
          features: [
            "Business strategy planning",
            "Operational engine optimization",
            "Corporate digital transformation consulting",
            "Leadership team training"
          ]
        },
        "e-learning-and-corporate-training-platforms": {
          overview: "Modern online training platforms, digitizing corporate knowledge effectively.",
          features: [
            "LMS learning management system",
            "Interactive digital content repository",
            "Personalized learning paths",
            "Automated certification system"
          ]
        },
        "supply-chain-data-integration": {
          overview: "Connecting and optimizing information flows in global supply chains.",
          features: [
            "SC data flow automation",
            "AI-driven demand forecasting",
            "Supply chain risk management",
            "Multi-channel logistics integration"
          ]
        },
        "corporate-media-production": {
          overview: "Top-tier media content creation, elevating brand value to new heights.",
          features: [
            "Viral Video & TVC production",
            "Professional brand photography",
            "Brand identity kit design",
            "Brand storytelling development"
          ]
        }
      },
    },
    advantages: {
      title: "Competitive",
      titleAccent: "Advantages",
      description:
        "AHV Ecosystem is proud to bring practical values and absolute peace of mind to customers and partners.",
      items: [
        {
          title: "Absolute Security",
          desc: "Applying the strictest information security standards, protecting business data safely 24/7.",
        },
        {
          title: "Cost Optimization",
          desc: "Flexible pay-as-you-go model helps save up to 40% in IT operation costs.",
        },
        {
          title: "Scalability",
          desc: "Independent and flexible architecture, easily expanding business scale without limits.",
        },
      ],
    },
    stats: {
      items: {
        "kinh-nghiem": "Years of Experience",
        "du-an": "Completed Projects",
        "doi-tac": "Global Partners",
        "chuyen-gia": "Core Experts",
      },
    },
    cta: {
      title: "Join the leading",
      titleAccent: "technology ecosystem",
      subtitle:
        "Together with AHV Holding, build new sustainable and prosperous values through the power of technology.",
      primary: "Partner with us",
      secondary: "Learn more",
      joinNow: "Join Now",
      learnMore: "Learn More",
    },
  },
};

export const newsPageTranslations = {
  vi: {
    hero: {
      badge: "Cập nhật mới nhất",
      title: "Tin tức &",
      titleAccent: "Sự kiện",
      subtitle:
        "Khám phá những bước tiến công nghệ đột phá, sự kiện nổi bật và tầm nhìn chiến lược tại AHV Holding.",
    },
    featured: {
      badge: "Tin nổi bật",
      readArticle: "Đọc toàn bộ bài viết",
    },
    filter: {
      all: "Tất cả",
      tech: "Công nghệ",
      event: "Sự kiện",
      culture: "Văn hóa",
      sports: "Thể thao",
      teambuilding: "Teambuilding",
      birthday: "Hoạt động sinh nhật",
      sortBy: "Sắp xếp theo:",
      latest: "Mới nhất",
      oldest: "Cũ nhất",
    },
    grid: {
      readMore: "Đọc tiếp",
      loadMore: "Xem thêm",
      loading: "Đang tải...",
    },
    newsItems: {},
    detail: {
      backToNews: "Quay lại tin tức",
      share: "Chia sẻ bài viết",
      latestNews: "Tin tức mới nhất",
      articleNotFound: "Không tìm thấy bài viết",
      newsletter: {
        title: "Bản tin",
        subtitle: "Cập nhật những tin tức và sự kiện mới nhất từ chúng tôi.",
        placeholder: "Địa chỉ email",
        subscribe: "Đăng ký",
      },
    },
    newsletter: {
      title: "Đừng bỏ lỡ",
      titleAccent: "bất kỳ tin tức nào",
      subtitle:
        "Đăng ký nhận bản tin của chúng tôi để cập nhật những thông tin mới nhất về công nghệ và các dự án của AHV Holding.",
      placeholder: "Địa chỉ email của bạn",
      cta: "Đăng ký ngay",
      privacy:
        "Chúng tôi cam kết bảo mật thông tin của bạn. Không spam, hủy bất cứ lúc nào.",
    },
  },
  en: {
    hero: {
      badge: "Latest Updates",
      title: "News &",
      titleAccent: "Events",
      subtitle:
        "Explore breakthrough technological advances, prominent events, and strategic vision at AHV Holding.",
    },
    featured: {
      badge: "Featured News",
      readArticle: "Read Full Article",
    },
    filter: {
      all: "All",
      tech: "Technology",
      event: "Events",
      culture: "Culture",
      sports: "Sports",
      teambuilding: "Teambuilding",
      birthday: "Birthday Activities",
      sortBy: "Sort by:",
      latest: "Latest",
      oldest: "Oldest",
    },
    grid: {
      readMore: "Read More",
      loadMore: "Load More News",
      loading: "Loading...",
    },
    newsItems: {
      "tet-van-nien-cham-nhip-khoi-nguyen-bat-tan": {
        title: "TET VAN NIEN – TOUCHING THE INFINITE RHYTHM OF ORIGIN",
        excerpt: "Tet is not only a moment of reunion, but also a time when the AHV family touches the same beat – the beat of creativity, of faith and...",
        content: "<p>Tet gifts from the Board of Directors not only carry strong traditional flavors but also serve as a 'mental charging station' – conveying care, acknowledging persistent efforts, and providing more motivation for each AHV member to stand firm on their dedicated journey ahead.</p>\n<p>We would like to express our gratitude to the AHV family for accompanying, making efforts, and dedicating fully in 2025.</p>",
        featureQuote: "Wishing the AHV family a new year 2026 SMOOTH SAILING – ADVANCING – BREAKTHROUGH SUCCESS!"
      },
      "83-ton-vinh-nhung-bong-hoa-cua-ahv": {
        title: "MARCH 8TH – HONORING THE FLOWERS OF AHV",
        excerpt: "Today is not only a special day for half the world, but also an opportunity for AHV Holding to stop, look back and send deepest thanks to...",
        content: "<p>Today is not only a special day for half of the world, but also an occasion for AHV Holding to pause, look back, and send our most sincere gratitude to the beautiful and talented 'flowers' who contribute daily to building the AHV family.</p>\n<p>Amidst the busy cycle of work, you always appear with positive energy, radiant smiles, and a spirit that fears no hardship. From creative ideas sparked in meetings to the silent efforts behind every project – all strongly bear the mark of the dedication and passion you bring every day.</p>\n<p>It is your companionship that has contributed to creating an inspiring work environment, where everyone not only accomplishes tasks together but also grows, connects, and spreads good values.</p>\n<p>AHV Holding cherishes every contribution – big or small – that you have made and continue to make. We are proud to have such talented, brave, and passionate companions on our shared journey of development.</p>\n<p>On International Women's Day, March 8th, AHV Holding would like to send to all of you our heartfelt wishes:</p>\n<p>💐 Wishing you to always be <strong>beautiful</strong> – because true beauty comes from confidence and an open heart. ✨ Always be <strong>confident</strong> – because you deserve the best. 🌟 Always be <strong>happy</strong> – in work, in life, and in every small everyday moment. 🌸 And forever <strong>shine</strong> – in your own unique and most brilliant way.</p>",
        featureQuote: "Happy March 8th – The Day of AHV Flowers! 🌺"
      },
      "happy-birthday-chuc-mung-sinh-nhat-nhan-su-thang-3": {
        title: "HAPPY BIRTHDAY – CONGRATULATIONS TO MARCH STAFF",
        excerpt: "March is not only the month of blooming flowers and cool weather, but also a special month marking the birth of members...",
        content: "<p>March is not only a month of blooming flowers and cool weather, but also a special month marking the birthdays of precious members in the AHV Holding family.</p>\n<p>On this occasion, the entire Board of Directors and the AHV Holding collective send you our most <strong>sincere, warm, and complete</strong> birthday wishes! 🎉</p>\n<p>Each member is an indispensable puzzle piece, contributing to the colorful and vibrant picture of AHV. Your silent or outstanding contributions, your persistent efforts every day are deeply recognized and appreciated. It is the enthusiasm and dedication of each individual that has been contributing to writing beautiful pages of history in the company's shared development journey.</p>\n<p>Entering this new age, AHV Holding sends you the best wishes:</p>\n<p>🌟 <strong>Abundant health</strong> – to always be full of energy to conquer all challenges. 😊 <strong>Complete joy</strong> – in work, in life, and with your loved ones. 💪 <strong>Positive energy</strong> – so that every day coming to the company is a day to look forward to. 🚀 <strong>Outstanding success</strong> – on your career path and personal goals. 💛 <strong>Fulfilling happiness</strong> – in your new age and all the years ahead.</p>\n<p>Thank you for choosing AHV Holding as a place to dedicate, attach, and grow together. Your companionship is a great motivation for the whole collective to keep moving forward.</p>",
        featureQuote: "🎂 Happy Birthday – A peaceful, brilliant new age filled with joy! 🎈🎊"
      },
      "tinh-than-the-thao-nang-luong-ket-noi-tai-ahv-holding": {
        title: "SPORTS SPIRIT – CONNECTIVE ENERGY AT AHV HOLDING",
        excerpt: "In modern life with continuous work cycle, AHV Holding always determines that physical and mental health care for the team is...",
        content: "<div class=\"prose-premium prose-slate max-w-none text-slate-700 leading-relaxed mb-12\">\n<p>In modern life with its non-stop work cycle, AHV Holding always determines that taking care of the physical and mental health of the team is one of our top priorities. Because we understand that — a healthy individual and a dynamic collective are the most solid foundation for every success.</p>\n<p>At AHV, sports are not simply physical training activities but have become an indispensable part of our corporate culture. This is a place where every member is comfortable being themselves — connecting, sharing, and recharging positive energy after stressful working hours. The laughter, cheering, and handshakes on the sports field have contributed to creating a warm, close, and vibrant atmosphere within the AHV family.</p>\n<p>We believe that a strong collective is built not only on professional capability, but also on solidarity, persistence, and an indomitable will to overcome challenges. Those qualities not only manifest in work — they are forged right on the football pitch, on the running track, and in every internal sports session of AHV.</p>\n<p>On the sports field, all gaps regarding departments or job positions are erased. There are no longer superiors or subordinates — everyone becomes true teammates, playing together with all their might, and standing side-by-side through every difficult moment in the match. The spirit of fair play, respect, and mutual cheering culture are always upheld — because that is exactly a miniature image of how AHV operates and develops every day.</p>\n<p>Winning is a joy, but what AHV cherishes most is the journey — the effort not to give up, the spirit of perseverance until the last minute, and the camaraderie bonded through every match. Those values do not stay on the sports field, but return with each member to the office, providing more motivation and enthusiasm in daily work.</p>\n<p>Looking back at the organized sports activities, AHV Holding is proud to have built a truly exciting and meaningful internal sports movement. From internal tournaments, morning exercise sessions, to team-building trips combining movement — all point toward a common goal: <strong>nurturing a healthy collective from the inside.</strong></p>\n<p>In the coming time, AHV Holding will continue to expand and promote sports activities, building more useful playgrounds so every member has the opportunity to participate, express themselves, and bond.</p>\n</div>",
        featureQuote: "A team with good physical strength, good spirit, and positive energy is a team ready to conquer any goal ahead. 💪🏆\nHealthy together – Strong together – Growing together! 🌟"
      },
      "ahv-holding-hanh-huong-chua-huong-djau-xuan": {
        title: "🌸 AHV HOLDING – SPRING PILGRIMAGE TO HUONG PAGODA",
        excerpt: "Immersed in the reverent crowd, every AHV member sincerely offered incense at the Buddhist gate, silently sending sincere wishes...",
        content: "<p>Not only a simple spiritual trip, this is also an opportunity for members of the AHV family to <strong>bond, share, and together aim toward common values</strong> – a solid foundation for the entire collective to enter the new year with a spirit of solidarity and a stronger will than ever before.</p>\n<p>The spiritual journey has concluded, but the warm feelings, faith, and motivation kindled from the trip will forever accompany each AHV member – empowering the whole collective to <strong>step firmly, confidently, and steadfastly</strong> on the path to conquering our set goals.</p>\n<p>With that spirit, AHV Holding enters the new year with complete faith and aspiration:</p>\n<p>A year full of <strong>health and peace</strong> for all employees and their families. A year <strong>reaping many achievements</strong>, successfully completing all proposed strategic goals. A year of <strong>solidarity and sustainable development</strong> – together continuing to write new, proud pages in the journey of AHV Holding.</p>\n<p><strong>New Spring – New Vigor – New Success! 🌺</strong></p>",
        featureQuote: "In the joyful atmosphere of the early days of the new year, the entire collective of AHV Holding made a pilgrimage to Huong Pagoda – one of the most sacred and meaningful spiritual destinations for Vietnamese people every spring."
      },
      "ahv-holding-year-end-party-2025": {
        title: "AHV HOLDING | YEAR END PARTY 2025: BREAKING LIMITS",
        excerpt: "On the evening of January 31, the Summary & Honoring party took place in a bustling atmosphere, where the AHV extended family, along with customers and partners, looked back at a memorable year and recharged energy for the new journey.",
        content: "<p>On the evening of January 31st, the Year End & Honoring Party took place in a bustling atmosphere, where the AHV extended family, along with customers and partners, looked back at a memorable year and recharged energy for the new journey.</p>",
        featureQuote: "YEAR END PARTY 2025: BREAKING LIMITS – READY TO WEAVE NEW MIRACLES"
      }
    },
    detail: {
      backToNews: "Back to News",
      share: "Share Article",
      latestNews: "Latest News",
      articleNotFound: "Article not found",
      newsletter: {
        title: "Newsletter",
        subtitle: "Stay updated with our latest news and events.",
        placeholder: "Email address",
        subscribe: "Subscribe",
      },
    },
    newsletter: {
      title: "Don't miss",
      titleAccent: "any updates",
      subtitle:
        "Subscribe to our newsletter to stay updated on the latest technology and AHV Holding projects.",
      placeholder: "Your email address",
      cta: "Subscribe Now",
      privacy:
        "We are committed to protecting your information. No spam, cancel anytime.",
    },
  },
};

export const careersPageTranslations = {
  vi: {
    hero: {
      badge: "Sự nghiệp tại AHV",
      title: "Gia nhập đội ngũ",
      titleAccent: "AHV Holding",
      subtitle:
        "Cùng chúng tôi xây dựng tương lai công nghệ bền vững. Khám phá cơ hội nghề nghiệp và phát triển bản thân trong môi trường sáng tạo.",
      viewPositions: "Xem vị trí đang tuyển",
      whyUs: "Tại sao chọn AHV?",
    },
    values: {
      title: "Giá Trị Cốt Lõi",
      description:
        "Chúng tôi tin rằng con người là tài sản quý giá nhất. Tại AHV Holding, bạn không chỉ làm việc, bạn đang cùng chúng tôi kiến tạo.",
      items: {
        "1": {
          title: "Môi trường Agile",
          description: "Quy trình hiện đại, linh hoạt và không ngừng sáng tạo.",
        },
        "2": {
          title: "Lộ trình rõ ràng",
          description:
            "Chính sách đào tạo và phát triển năng lực được ưu tiên hàng đầu.",
        },
        "3": {
          title: "Công nghệ tiên phong",
          description:
            "Luôn tiếp cận và ứng dụng các công nghệ mới nhất trên thế giới.",
        },
        "4": {
          title: "Văn hóa mở",
          description:
            "Khuyến khích chia sẻ ý tưởng và trao quyền quyết định cho mỗi cá nhân.",
        },
        "5": {
          title: "Chăm sóc toàn diện",
          description:
            "Đãi ngộ hấp dẫn, bảo hiểm sức khỏe cao cấp cho nhân viên và gia đình.",
        },
        "6": {
          title: "Cân bằng cuộc sống",
          description:
            "Thời gian làm việc linh hoạt, chú trọng sự gắn kết qua các hoạt động teambuilding.",
        },
      },
    },
    positions: {
      title: "Vị trí đang tuyển",
      subtitle: "Tìm kiếm cơ hội bứt phá và khẳng định bản thân.",
      categories: {
        all: "Tất cả",
        tech: "Kỹ thuật",
        design: "Thiết kế",
        management: "Quản lý",
      },
      salary: "Cạnh tranh",
      applyNow: "Ứng tuyển ngay",
      noFit: "Không tìm thấy vị trí phù hợp? Đừng lo lắng!",
      uploadCV: "Tải lên CV của bạn",
      deadline: "Hạn nộp",
      viewDetails: "Xem chi tiết",
      noJobsFound: "Không tìm thấy vị trí tuyển dụng nào phù hợp.",
      locations: {
        "Hà Nội": "Hà Nội",
        "TPHCM": "TP. Hồ Chí Minh",
        "Đà Nẵng": "Đà Nẵng",
      },
      types: {
        "Full-time": "Toàn thời gian",
        "Part-time": "Bán thời gian",
        "Hybrid": "Kết hợp",
        "Remote": "Từ xa",
      },
      listings: {
        "senior-backend-developer": {
          title: "Senior Backend Developer",
          location: "Hà Nội",
          type: "Toàn thời gian",
        },
        "ui-ux-designer": {
          title: "UI/UX Designer",
          location: "Thái Nguyên",
          type: "Toàn thời gian",
        },
        "it-project-manager": {
          title: "IT Project Manager",
          location: "Hà Nội",
          type: "Toàn thời gian",
        },
      },
    },
    cta: {
      title: "Kiến tạo tương lai",
      titleAccent: "cùng chúng tôi",
      subtitle:
        "Chúng tôi luôn tìm kiếm những con người khao khát đổi mới và mong muốn tạo ra những tác động tích cực cho xã hội thông qua công nghệ.",
      explore: "Khám phá cơ hội",
    },
    detail: {
      backToCareers: "Quay lại tuyển dụng",
      applyNow: "Ứng tuyển ngay",
      jobDescription: "Mô tả công việc",
      requirements: "Yêu cầu công việc",
      benefits: "Quyền lợi",
      deadline: "Hạn nộp hồ sơ",
      jobNotFound: "Không tìm thấy vị trí",
      location: "Địa điểm",
      type: "Hình thức",
      share: "Chia sẻ vị trí này",
      copyLink: "Sao chép liên kết",
      sidebarSubtitle: "Sẵn sàng bứt phá sự nghiệp cùng AHV Holding? Gửi hồ sơ ngay hôm nay để nhận phản hồi từ đội ngũ tuyển dụng.",
    },
    application: {
      title: "Ứng tuyển vị trí",
      defaultTitle: "Nộp Hồ Sơ Ứng Tuyển",
      subtitle: "Vui lòng điền đầy đủ thông tin bên dưới để ứng tuyển.",
      form: {
        name: "Họ và Tên",
        phone: "Số điện thoại",
        email: "Email liên hệ",
        cv: "Tải lên CV (PDF, DOCX)",
        message: "Thư xin việc",
        placeholder: {
          name: "Nhập họ và tên của bạn",
          phone: "Nhập số điện thoại liên lạc",
          email: "Ex: nguyenvana@gmail.com",
          cv: "Click để tải lên hồ sơ",
          cvSub: "hoặc Kéo thả file CV vào đây (Max: 15MB)",
          cvSelected: "File đã chọn",
          message: "Giới thiệu bản thân và lý do bạn phù hợp với vị trí này..."
        },
        submit: "Gửi Hồ Sơ",
        submitting: "Đang xử lý...",
        cancel: "Hủy bỏ"
      },
      success: {
        title: "Gửi Thành Công!",
        subtitle: "Cảm ơn bạn đã quan tâm. Chúng tôi sẽ liên hệ sớm nhất."
      },
      error: {
        noCv: "Vui lòng tải lên CV của bạn.",
        cvTooLarge: "Dung lượng CV phải nhỏ hơn 15MB",
        failed: "Đã xảy ra lỗi khi gửi hồ sơ. Vui lòng thử lại.",
        slowNetwork: "Mạng chậm, tải CV quá lâu. Vui lòng thử lại hoặc dùng file nhỏ hơn."
      }
    }
  },
  en: {
    hero: {
      badge: "Careers at AHV",
      title: "Join the Team",
      titleAccent: "AHV Holding",
      subtitle:
        "Build a sustainable technology future with us. Explore career opportunities and develop yourself in a creative environment.",
      viewPositions: "View Open Positions",
      whyUs: "Why choose AHV?",
    },
    values: {
      title: "Core Values",
      description:
        "We believe people are the most valuable asset. At AHV Holding, you're not just working, you're co-creating with us.",
      items: {
        "1": {
          title: "Agile Environment",
          description: "Modern, flexible processes and constant creativity.",
        },
        "2": {
          title: "Clear Roadmap",
          description:
            "Training and competency development policies are a top priority.",
        },
        "3": {
          title: "Pioneering Technology",
          description:
            "Always accessing and applying the latest global technologies.",
        },
        "4": {
          title: "Open Culture",
          description:
            "Encouraging idea sharing and empowering individual decision-making.",
        },
        "5": {
          title: "Comprehensive Care",
          description:
            "Attractive benefits, premium health insurance for employees and families.",
        },
        "6": {
          title: "Work-Life Balance",
          description:
            "Flexible working hours, focusing on engagement through teambuilding activities.",
        },
      },
    },
    positions: {
      title: "Open Positions",
      subtitle: "Find opportunities to break through and affirm yourself.",
      categories: {
        all: "All",
        tech: "Technical",
        design: "Design",
        management: "Management",
      },
      salary: "Competitive",
      applyNow: "Apply Now",
      noFit: "Can't find a suitable position? Don't worry!",
      uploadCV: "Upload your CV",
      deadline: "Deadline",
      viewDetails: "View Details",
      noJobsFound: "No suitable job vacancies found.",
      locations: {
        "Hà Nội": "Hà Nội",
        "TPHCM": "TP. Hồ Chí Minh",
        "Đà Nẵng": "Đà Nẵng",
      },
      types: {
        "Full-time": "Toàn thời gian",
        "Part-time": "Bán thời gian",
        "Hybrid": "Kết hợp",
        "Remote": "Từ xa",
      },
      listings: {
        "senior-frontend-developer-reacttypescript": {
          title: "Senior Frontend Developer (React/TypeScript)",
          description: "<p>We are looking for a Frontend expert to lead the interface development for the AHV Holding ecosystem. You will be responsible for optimizing user experience and ensuring aesthetics and performance for strategic products.</p>",
           requirements: [
            "At least 4 years of experience working with React.js and Next.js.",
            "Proficient in TypeScript, Tailwind CSS, and State management (Redux/Zustand).",
            "Experience in Web Performance optimization and technical SEO.",
            "Good UI/UX mindset, knowing how to use Figma is a plus."
          ],
          benefits: [
            "Competitive salary up to $2000+",
            "13th month salary and project bonus",
            "Premium health insurance",
            "Modern equipment provided"
          ]
        },
        "business-analyst-ba": {
          title: "Business Analyst (BA)",
          description: "Analyze business requirements and convert them into technical documents for the development team.",
          requirements: [
            "Logical analysis and system thinking skills",
            "Proficient in process drawing (BPMN, UML)",
            "Good listening and communication skills"
          ]
        },
        "it-security-audit": {
          title: "IT Security Audit",
          description: "Evaluate and control security vulnerabilities, ensuring absolute information security for the system.",
          requirements: [
            "CEH or OSCP certification",
            "Experience in Penetration Testing",
            "Understanding of international security standards"
          ]
        },
        "content-creator": {
          title: "Content Creator",
          description: "Create engaging content on social media platforms (TikTok, Facebook, LinkedIn) for AHV.",
          requirements: [
            "Good and creative writing skills",
            "Ability to use simple video editing tools (Capcut, Premiere)",
            "Sensitive to the latest trends"
          ]
        },
        "project-manager-tech": {
          title: "Project Manager (Tech)",
          description: "Manage the progress, budget, and quality of key software projects.",
          requirements: [
            "PMP or Agile/Scrum Master certification is a plus",
            "Team management and risk management skills",
            "Good technical background to communicate with the Dev team"
          ]
        },
        "data-scientist": {
          title: "Data Scientist",
          description: "Analyze big data to find business trends and support strategic decision making.",
          requirements: [
            "Proficient in Python/R and Machine Learning libraries",
            "Knowledge of SQL and Big Data processing",
            "Ability to present data reports visually"
          ]
        },
        "devops-engineer": {
          title: "DevOps Engineer",
          description: "Build and optimize the CI/CD system, ensuring stability and security for the Cloud infrastructure.",
          requirements: [
            "Experience working with Docker, Kubernetes",
            "Proficient in AWS or Google Cloud Platform",
            "Ability to use Automation tools like Terraform, Ansible"
          ]
        },
        "hr-business-partner": {
          title: "HR Business Partner",
          description: "Act as a bridge between HR strategy and business goals of each member unit.",
          requirements: [
            "Understanding of labor law and HR management processes",
            "Good communication and persuasion skills",
            "Experience working in multi-industry conglomerates is an advantage"
          ]
        },
        "uiux-designer": {
          title: "UI/UX Designer",
          description: "Design smooth user experiences and modern interfaces for AHV Holding's technology products.",
          requirements: [
            "Proficient in Figma, Adobe Creative Suite",
            "Good mindset about User Flow and Wireframe",
            "Have a Portfolio demonstrating real App/Web design projects"
          ]
        },
        "digital-marketing-specialist": {
          title: "Digital Marketing Specialist",
          description: "Responsible for planning and executing multi-channel marketing campaigns to enhance AHV brand identity.",
          requirements: [
            "Minimum 3 years of experience in Digital Marketing",
            "In-depth skills in running Facebook, Google Ads",
            "Ability to analyze data and optimize conversions"
          ]
        },
        "senior-fullstack-developer-nodejsreact": {
          title: "Senior Fullstack Developer (Node.js/React)",
          description: "We are looking for a Senior Fullstack Developer to lead the development team of digital transformation solutions for the group.",
          requirements: [
            "At least 5 years of experience with Node.js and React",
            "Proficient in MongoDB and Microservices system design",
            "Good problem-solving and teamwork skills"
          ]
        }
      },
    },
    cta: {
      title: "Shape the Future",
      titleAccent: "With Us",
      subtitle:
        "We are always looking for people who hunger for innovation and want to create positive social impacts through technology.",
      explore: "Explore Opportunities",
    },
    detail: {
      backToCareers: "Back to Careers",
      applyNow: "Apply Now",
      jobDescription: "Job Description",
      requirements: "Job Requirements",
      benefits: "Benefits",
      deadline: "Application Deadline",
      jobNotFound: "Job not found",
      location: "Location",
      type: "Type",
      share: "Share this position",
      copyLink: "Copy Link",
      sidebarSubtitle: "Ready to breakthrough your career with AHV Holding? Submit your application today to receive a response from our recruitment team.",
    },
    application: {
      title: "Apply for position",
      defaultTitle: "Submit Application",
      subtitle: "Please fill in the information below to apply.",
      form: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Contact Email",
        cv: "Upload CV (PDF, DOCX)",
        message: "Cover Letter",
        placeholder: {
          name: "Enter your full name",
          phone: "Enter your phone number",
          email: "Ex: johndoe@gmail.com",
          cv: "Click to upload your CV",
          cvSub: "or Drag & Drop your CV file here (Max: 15MB)",
          cvSelected: "Selected file",
          message: "Tell us about yourself and why you're a good fit..."
        },
        submit: "Submit Application",
        submitting: "Processing...",
        cancel: "Cancel"
      },
      success: {
        title: "Sent Successfully!",
        subtitle: "Thank you for your interest. Our recruitment team will review and contact you soon."
      },
      error: {
        noCv: "Please upload your CV.",
        cvTooLarge: "CV file must be smaller than 15MB",
        failed: "Failed to submit application. Please try again.",
        slowNetwork: "Upload is taking too long on a slow connection. Please retry or use a smaller file."
      }
    }
  },
};

// No-op - removed nested definitions
